import { useEffect } from "react";
import { Outlet, useLocation } from "react-router";
import { startAnalytics, trackPageView } from "@/lib/analytics";

/**
 * Wraps every route: records which screen someone is on. Ids are stripped from
 * the path, so `/app/boards/<id>` counts as `/app/boards/:id` and no event ever
 * carries anything about who a person is.
 */
export function TrackPageViews() {
  const { pathname } = useLocation();
  useEffect(() => {
    startAnalytics();
  }, []);
  useEffect(() => {
    trackPageView(pathname);
  }, [pathname]);
  return <Outlet />;
}
